module.exports = __webpack_public_path__ + "img/shiyong.ea79e49f.png";